import React, { useEffect, useRef, useState } from "react"
import CustomLink from "./CustomLink"
import { setNonDispalyValue, tableLinkColumn } from "./EventHandler"

const CustomBOMTable = (props) => {
   const [changeOccure, setChangeOccure] = useState(false)
   const [partName] = useState(props.partName)


   useEffect(() => {
      if (changeOccure) {
         const delay = setTimeout(() => {
            props.handleDiffCategory(props.name);
         }, 1000); // Add a 1-second delay
   
         // Cleanup the timeout to avoid memory leaks
         return () => clearTimeout(delay);
      }
   }, [changeOccure, props.name, props.handleDiffCategory]);

   const [data, setData] = useState([]);
   const [previousData, setPreviousData] = useState([]);

   useEffect(() => {
      if (props.data) {
         setData(props.data);
      }
      if (props.previousData) {
         setPreviousData(props.previousData);
      }
   }, [props.data, props.previousData]);

   const containerRef = useRef(null)
   const table1Ref = useRef(null)
   const table2Ref = useRef(null)

   useEffect(() => {
      const synchronizeRowHeights = () => {
         const table1Rows = table1Ref.current?.querySelectorAll("tr") || [];
         const table2Rows = table2Ref.current?.querySelectorAll("tr") || [];
   
         // Ensure both tables have the same number of rows
         const rowCount = Math.min(table1Rows.length, table2Rows.length);
   
         for (let i = 0; i < rowCount; i++) {
            const table1Row = table1Rows[i];
            const table2Row = table2Rows[i];
   
            if (table1Row && table2Row) {
               // Get the maximum height of the two rows
               const maxHeight = Math.max(table1Row.offsetHeight, table2Row.offsetHeight);
   
               // Apply the maximum height to both rows
               table1Row.style.height = `${maxHeight}px`;
               table2Row.style.height = `${maxHeight}px`;
            }
         }
      };
   
      // Delay synchronization to ensure rows are rendered
      const timeout = setTimeout(() => {
         synchronizeRowHeights();
      }, 100); // 100ms delay
   
      // Synchronize row heights on window resize
      window.addEventListener("resize", synchronizeRowHeights);
   
      return () => {
         clearTimeout(timeout);
         window.removeEventListener("resize", synchronizeRowHeights);
      };
   }, [data, previousData]);

   useEffect(() => {
      let isSyncing = false

      const handleScrollTable1 = () => {
         if (isSyncing) return
         isSyncing = true
         if (table2Ref.current) {
            table2Ref.current.scrollTop = table1Ref.current.scrollTop || 0
            table2Ref.current.scrollLeft = table1Ref.current.scrollLeft || 0
         }
         isSyncing = false
      }

      const handleScrollTable2 = () => {
         if (isSyncing) return
         isSyncing = true
         if (table1Ref.current) {
            table1Ref.current.scrollTop = table2Ref.current.scrollTop || 0
            table1Ref.current.scrollLeft = table2Ref.current.scrollLeft || 0
         }
         isSyncing = false
      }

      const table1 = table1Ref.current
      const table2 = table2Ref.current

      if (table1) {
         table1.addEventListener("scroll", handleScrollTable1)
      }

      if (table2) {
         table2.addEventListener("scroll", handleScrollTable2)
      }

      return () => {
         if (table1) {
            table1.removeEventListener("scroll", handleScrollTable1)
         }
         if (table2) {
            table2.removeEventListener("scroll", handleScrollTable2)
         }
      }
   }, [data, previousData])

   const compareObjects = (current, previous, parentKey = "") => {
      let differences = {}

      if (
         typeof current === "object" &&
         current !== null &&
         typeof previous === "object" &&
         previous !== null
      ) {
         // If both are objects, compare their keys recursively
         const keys = new Set([...Object.keys(current), ...Object.keys(previous)])
         keys.forEach((key) => {
            if (key.toLowerCase() === "id" || key.toLowerCase() === "link") {
               return
            }
            const newKey = parentKey ? `${parentKey}.${key}` : key // Flatten the key
            Object.assign(
               differences,
               compareObjects(current[key], previous[key], newKey)
            )
         })
      } else {
         // For primitive values, compare directly
         const flattenedKey = parentKey
         differences[flattenedKey] = current === previous ? "same" : "different"
      }

      return differences
   }

   const isObjectEmpty = (obj) => {
      return Object.values(obj).every((value) => {
         if (typeof value === "object" && value !== null) {
            return isObjectEmpty(value)
         }
         return !value
      })
   }

   const differencesInEachRow = (index) => {
      let differencesInRow = {}

      if (data[index] && previousData[index]) {
         if (!isObjectEmpty(data[index]) && !isObjectEmpty(previousData[index])) {
            differencesInRow = compareObjects(data[index], previousData[index])
         }
      }

      return differencesInRow
   }

   const getHeader = () => {
      let keys = getKeys()
      return keys.map((key, index) => {
         if (setNonDispalyValue(key)) {
            return null
         }
         return (
            <th key={key}>
               <span>{key}</span>
            </th>
         )
      })
   }

   const getRowsData = (data) => {
      let items = data
      let keys = getKeys()
      let backgroundColor = ""
      return items.map((row, index) => {
         const isRowEmpty = (row) => {
            if (!row || typeof row !== "object") return true

            return Object.values(row).every((value) => {
               if (Array.isArray(value)) {
                  return value.length === 0 || value.every((item) => isRowEmpty(item))
               } else if (typeof value === "object" && value !== null) {
                  return isRowEmpty(value)
               }
               return !value
            })
         }

         if (isRowEmpty(row)) {
            // Render an empty row
            if (changeOccure == false) {
               setChangeOccure(true)
               props.handleDiffCategory(props.name)
            }
            return (
               <tr key={index}>
                  <td colSpan={keys.length} style={{ backgroundColor: "#ffcccc" }}></td>
               </tr>
            )
         }

         let differencesInRow = differencesInEachRow(index)

         if (Object.values(differencesInRow).includes("different")) {
            if (changeOccure == false) {
               setChangeOccure(true)
               props.handleDiffCategory(props.name)
            }
            backgroundColor = "#ffcccc"
         } else {
            backgroundColor = "white"
         }
         return (
            <tr key={index} style={{ backgroundColor: backgroundColor }}>
               <RenderRow key={index} data={row} keys={keys} differencesInRow={differencesInRow} />
            </tr>
         )
      })
   }

   const getKeys = function () {
      if (!data || data.length === 0) {
         return []; 
      }
      return Object.keys(data[0]);
   };

   const getColumnKeys = function (columKeyInfo) {
      return Object.keys(columKeyInfo)
   }

   const getLinksArray = function (data, link, id, color, fontWeight) {
      let elements = data.map((value, index) => {
         let num = index + 1
         if (
            link[index] &&
            link[index].trim() !== "" &&
            id[index] &&
            id[index].trim() !== "" &&
            id[index].toLowerCase().trim() !== "no access"
         ) {
            return (
               <span key={index}>
                  <CustomLink
                     id={id[index].trim()}
                     link={link[index].trim()}
                     name={value}
                  />
                  {num === data.length ? "" : "|"}
               </span>
            )
         } else {
            return (
               <span key={index} style={{ color: color, fontWeight: fontWeight }}>
                  {value}
                  {num === data.length ? "" : "|"}
               </span>
            )
         }
      })
      return elements
   }

   const RenderColumn = function (props) {
      return props.keys.map((key, index) => {
         if (props.data[key] != null) {
            if (
               (key.toLowerCase() === "sp" ||
                  key.toLowerCase() === "ln") &&
               (props.parentKey === "Substitute Parts (SP) Alternate (Alt)" ||
                  props.parentKey === "Substitute Parts(SP) Alternate(Alt)" ||
                  props.parentKey === "substituteparts(sp)alternate(alt)" ||
                  props.parentKey === "substituteparts(sp)alternate(alt)layername(ln)")
            ) {
               let nameData = props.data[key]["name"]
                  ? props.data[key]["name"].split("|")
                  : []
               let nameLink = props.data[key]["link"]
                  ? props.data[key]["link"].split("|")
                  : []
               let nameId = props.data[key]["id"] ? props.data[key]["id"].split("|") : []
               let color = ''
               let fontWeight = ''

               if (
                  props.differencesInRow[`${props.parentKey}.SP.name`] === "different" ||
                  props.differencesInRow[`${props.parentKey}.sp.name`] === "different"
               ) {
                  color = "red"
                  fontWeight = 'bold'
               }
               let getnamelinks = getLinksArray(nameData, nameLink, nameId, color, fontWeight)
               return (
                  <div key={index}>
                     <span className={props.isbold ? "bomFontClass" : ""}>{key}: </span>
                     <span>{getnamelinks}</span>
                  </div>
               )
            } else if (
               (key.toLowerCase() === "alt" ||
                  key.toLowerCase() === "ln") &&
               (props.parentKey === "Substitute Parts (SP) Alternate (Alt)" ||
                  props.parentKey === "Substitute Parts(SP) Alternate(Alt)" ||
                  props.parentKey === "substituteparts(sp)alternate(alt)" ||
                  props.parentKey === "substituteparts(sp)alternate(alt)layername(ln)")
            ) {
               let nameData = props.data[key]["name"]
                  ? props.data[key]["name"].split("|")
                  : []
               let nameLink = props.data[key]["link"]
                  ? props.data[key]["link"].split("|")
                  : []
               let nameId = props.data[key]["id"] ? props.data[key]["id"].split("|") : []
               let color = ''
               let fontWeight = ''

               if (
                  props.differencesInRow[`${props.parentKey}.Alt.name`] === "different" ||
                  props.differencesInRow[`${props.parentKey}.alt.name`] === "different"
               ) {
                  color = "red"
                  fontWeight = 'bold'
               }
               let getnamelinks = getLinksArray(nameData, nameLink, nameId, color, fontWeight)
               return (
                  <div key={index}>
                     <span className={props.isbold ? "bomFontClass" : ""}>{key}: </span>
                     <span>{getnamelinks}</span>
                  </div>
               )
            } else if (props.data[key] && setNonDispalyValue(key)) {
               return null
            } else {
               if (props.childKeysWithStatus[key] === 'different') {
                  return (
                     <div key={index}>
                        <span style={{ color: "red", fontWeight: 'bold' }}>
                           {props.data[key]}
                        </span>
                     </div>
                  )
               }
               return (
                  <div key={index}>
                     <span className={props.isbold ? "bomFontClass" : ""}>{key}:</span>{" "}
                     <span>{props.data[key]}</span>
                  </div>
               )
            }
         } else return null
      })
   }

   const RenderLinkColumn = function (props) {
      return props.keys.map((key, index) => {
         if (
            props.data[key] &&
            props.data["id"] &&
            props.data["id"].toLowerCase().trim() !== "no access" &&
            (key.toLowerCase() === "n" ||
               key.toLowerCase() === "ppn" ||
               key.toLowerCase() === "sp")
         ) {
            let name = props.data[key]

            return (
               <div key={index} style={{ minWidth: "9rem" }}>
                  <span className={props.isbold ? "bomFontClass" : ""}>{key}: </span>{" "}
                  <span>
                     {props.data["link"] ? (
                        <CustomLink
                           id={props.data["id"]}
                           link={props.data["link"]}
                           name={name}
                        />
                     ) : (
                        <span>{name}</span>
                     )}
                  </span>
               </div>
            )
         } else if (props.data[key] && setNonDispalyValue(key)) {
            return null
         }

         // else if (props.data[key])
         else if (props.data[key] != null){
            if (props.childKeysWithStatus[key] === "different") {
               return (
                  <div key={index}>
                     <span style={{ color: "red", fontWeight: 'bold' }}>
                        {props.data[key]}
                     </span>
                  </div>
               )
         } else {

            return (
               <div key={index}>
                  <span className={props.isbold ? "bomFontClass" : ""}>{key}: </span>{" "}
                  <span>{props.data[key]}</span>
               </div>
            )
         }
      }
         else return null
      })
   }
   const RenderParentLinkColumn = function (props) {
      return props.keys.map((key, index) => {
         if (
            props.data[key] &&
            props.data["id"] &&
            props.data["id"].toLowerCase().trim() !== "no access" &&
            key.toLowerCase() === "name"
         ) {
            let name = props.data[key]
            return (
               <div key={index} style={{ minWidth: "9rem" }}>
                  <span>
                     {props.data["link"] ? (
                        <CustomLink
                           id={props.data["id"]}
                           link={props.data["link"]}
                           name={name}
                        />
                     ) : (
                        <span>{name}</span>
                     )}
                  </span>
               </div>
            )
         } else if (props.data[key] && setNonDispalyValue(key)) {
            return null
         }
         // else if (props.data[key])
         else if (props.data[key] != null){
            let status = props.childKeysWithStatus[key]
            let statusColor = ""
            let fontWeight = ''
            if (status === "different") {
               statusColor = "red"
               fontWeight = 'bold'
            } 
            return (
               <div key={index}>
                  <span style={{ color: statusColor, fontWeight: fontWeight }}>
                     <span>{props.data[key]}</span> 
                  </span>
               </div>
            )
         }
         else return null
      })
   }

   const RenderRow = (props) => {
      var colKeys = []
      return props.keys.map((key, index) => {
         const childKeysWithStatus = Object.keys(props.differencesInRow || {})
                .filter((diffKey) => diffKey.startsWith(`${key}.`)) 
                .reduce((acc, diffKey) => {
                    const childKey = diffKey.split('.').pop(); 
                    acc[childKey] = props.differencesInRow[diffKey]; 
                    return acc;
                }, {});
         if (
            props.data[key] &&
            typeof props.data[key] == "object" &&
            (key === "Name(N) Rev(R)" ||
               key === "Name(N) Type(T)" ||
               key === "Product Part Name(PPN) Product Part Revision(PPR)")
         ) {
            colKeys = getColumnKeys(props.data[key])
            return (
               <td key={index}>
                  <RenderLinkColumn
                     isbold={true}
                     id={props.data["id"]}
                     link={props.data["link"]}
                     data={props.data[key]}
                     keys={colKeys}
                     childKeysWithStatus={childKeysWithStatus}
                  />
               </td>
            )
         }
         if (
            props.data[key] &&
            typeof props.data[key] == "object" &&
            key === "Parent Name"
         ) {
            colKeys = getColumnKeys(props.data[key])
            return (
               <td key={index}>
                  <RenderParentLinkColumn
                     isbold={true}
                     id={props.data["id"]}
                     link={props.data["link"]}
                     data={props.data[key]}
                     keys={colKeys}
                     childKeysWithStatus={childKeysWithStatus}
                  />
               </td>
            )
         }
         if (
            props.data[key] &&
            typeof props.data[key] == "object" &&
            (key.toLowerCase().split(" ").join("") ===
               "substituteparts(sp)alternate(alt)" ||
               key.toLowerCase().split(" ").join("") ===
                  "substituteparts(sp)/alternate(alt)")
         ) {
            colKeys = getColumnKeys(props.data[key])
            return (
               <td key={index}>
                  <RenderColumn
                     isbold={true}
                     data={props.data[key]}
                     keys={colKeys}
                     parentData={props.data}
                     parentKey={key}
                     childKeysWithStatus={childKeysWithStatus}
                     differencesInRow={props.differencesInRow}
                  />
               </td>
            )
         }
         if (
            props.data[key] &&
            typeof props.data[key] == "object" &&
            (key.toLowerCase().split(" ").join("") ===
               "substituteparts(sp)alternate(alt)layername(ln)" ||
               key.toLowerCase().split(" ").join("") ===
                  "substituteparts(sp)/alternate(alt)/layername(ln)")
         ) {
            colKeys = getColumnKeys(props.data[key])
            return (
               <td key={index}>
                  <RenderColumn
                     isbold={true}
                     data={props.data[key]}
                     keys={colKeys}
                     parentData={props.data}
                     parentKey="substituteparts(sp)alternate(alt)layername(ln)"
                  />
               </td>
            )
         }

         if (props.data[key] && typeof props.data[key] == "object") {
            colKeys = getColumnKeys(props.data[key])
            return (
               <td key={index}>
                  <RenderColumn 
                     isbold={true} 
                     data={props.data[key]} 
                     keys={colKeys} 
                     childKeysWithStatus={childKeysWithStatus}
                     />
               </td>
            )
         } else if (
            key.toLowerCase().trim() === "tup name" &&
            props.data["tupId"] &&
            props.data["tupId"].toLowerCase().trim() !== "no access"
         ) {
            let tup_Name = props.data[key]
            return tableLinkColumn(
               props.data["tupId"],
               props.data["tupLink"],
               tup_Name,
               index
            )
         } else if (
            key.toLowerCase() === "name" &&
            props.data["link"] &&
            props.data["link"] !== ""
         ) {
            let name = props.data[key]
            return tableLinkColumn(props.data["id"], props.data["link"], name, index)
         } else if (setNonDispalyValue(key)) {
            return null
         } else if (
            key.toLowerCase().trim() === "batch/unit size" ||
            key.toLowerCase().trim() === "target" ||
            key.toLowerCase().trim() === "comment"
         ) {
            let batchValue = props.data[key] ? props.data[key].split("\n") : []
            let batchelements = batchValue.map((key, index) => {
               return (
                  <div key={index}>
                     {key.includes(":") ? (
                        <span>
                           <b>{key.split(":")[0]}</b>:{key.split(":")[1]}
                        </span>
                     ) : (
                        <span>{key}</span>
                     )}
                  </div>
               )
            })
            return <td key={index}>{batchelements}</td>
         } else {
            if(props.differencesInRow[key] === 'different'){
               return (
                  <td key={index}>
                     <span style={{ color: "red", fontWeight: 'bold' }}>
                        {props.data[key]}
                     </span>
                  </td>
               )
            }
            return <td key={index}>{props.data[key]}</td>
         }
      })
   }

   return (
      <div>
         <div ref={containerRef} style={{ display: "flex" }}>
            <div
               ref={table1Ref}
               style={{ width: "50%", overflow: "auto", maxHeight: "60vh" }}
            >
               {props.revision && props.revision !== "" && (
                  <div
                     style={{
                        position: "sticky",
                        top: "0",
                        backgroundColor: "#EEEEEE",
                        textAlign: "center",
                        fontWeight: "bold",
                     }}
                  >
                     {partName}{" "}{props.revision["releaseRevision"]}
                  </div>
               )}
               {props.data && props.data.length > 0 && (
                  <table className="tableBorder">
                     <thead>
                        <tr>
                           <th
                              style={{
                                 visibility:
                                    props.isHeader !== "false" ? "visible" : "collapse",
                              }}
                           ></th>
                        </tr>
                        <tr style={{backgroundColor:"#eee"}}>{getHeader()}</tr>
                     </thead>
                     <tbody>{getRowsData(data)}</tbody>
                  </table>
               )}
            </div>

            <div
               ref={table2Ref}
               style={{ width: "50%", overflow: "auto", maxHeight: "60vh" }}
            >
               {props.revision && props.revision !== "" && (
                  <div
                     style={{
                        position: "sticky",
                        top: "0",
                        backgroundColor: "#EEEEEE",
                        textAlign: "center",
                        fontWeight: "bold",
                     }}
                  >
                     {partName}{" "}{props.revision["obsoleteRevision"]}
                  </div>
               )}
               {previousData && previousData.length > 0 && (
                  <table className="tableBorder">
                     <thead>
                        <tr>
                           <th
                              style={{
                                 visibility:
                                    props.isHeader !== "false" ? "visible" : "collapse",
                              }}
                           ></th>
                        </tr>
                        <tr style={{backgroundColor:"#eee"}}>{getHeader()}</tr>
                     </thead>
                     <tbody>{getRowsData(previousData)}</tbody>
                  </table>
               )}
            </div>
         </div>
      </div>
   )
}
export default CustomBOMTable
